export enum MediaContentType {
  MEDIA = "media",
  SPOTIFY = "spotify",
}

export enum View {
  FULL = "full",
  CONTAINER = "container",
}
